import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-map-marker1-icon',
  templateUrl: './map-marker1.component.html'
})
export class MapMarker1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
